import { createPinia } from 'pinia';
import { resetAllStoresUtil } from '@stores/auth/resetAllStores.js';

/**
 * Creates and exports a single Pinia instance to be used throughout the application.
 * This ensures consistent state management across all components and services.
 */
const pinia = createPinia();

/**
 * Reset states for all registered Pinia stores.
 * This wrapper is provided so that tests and other modules can
 * access the `resetAllStores` helper via `@stores/index.js`,
 * avoiding deep imports into the utils directory and keeping
 * store-related helpers colocated.
 */
export const resetAllStores = () => {
    resetAllStoresUtil();
};

export default pinia;
